import 'semantic-ui-less/definitions/modules/dimmer.less';import _default from './Dimmer';
export { _default as default };